(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-custom"] && !Shopify.designMode) return;
  try {
    

/*---------------- Featured Slider ------------------*/
    $('.collection-products').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: true,
        responsive: [
            {
                breakpoint: 1501,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-template"]) return;
  try {
    
 $(document).ready(function () {
    attachClickEvent();
  });

  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
  pInfScrNode = $('.more').last();  
  pInfScrURL = $('.more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".collection-matrix");
        filteredData.insertBefore( $("#product-list-foot") );         
        pInfScrLoading = false;
        /*$('li.singleproduct').setAllToMaxHeight();*/
        attachClickEvent();
      },
      dataType: "html"
    });

  }
}

function attachClickEvent(){
  $('li.more a').click(function(event){
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });
}        


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
 $(document).ready(function () {
    attachClickEvent();
  });

  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
  pInfScrNode = $('.more').last();  
  pInfScrURL = $('.more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".forlistview");
        filteredData.insertBefore( $("#product-list-foot") );         
        pInfScrLoading = false;
        /*$('li.singleproduct').setAllToMaxHeight();*/
        attachClickEvent();
      },
      dataType: "html"
    });

  }
}

function attachClickEvent(){
  $('li.more a').click(function(event){
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });
}        


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
    

$(window).load(function () {
    if ($('.meso-wrap').length) {
        $('.meso-wrap').masonry({
            itemSelector: '.meso-wrap .promo-wrap',
            columnWidth: '.meso-wrap .grid-sizer'
        });
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*---------------- Search Popup ------------------*/
    $(".search-toggle").on('click', function (e) {
        $(".header-wrap").toggleClass('search-active');
        e.preventDefault();
    });

     /*---------------- Responsive Menu ------------------*/
    $(".nav-trigger").on('click', function (e) {
        $("body").toggleClass('off-canvas-body');
        $(".menu-bar").toggleClass("off-canvas");
        e.preventDefault();
    });
    if ($(window).width() < 768) {
        $('.primary-navbar .dropdown > a').on("click", function (e) {
            $(this).next('.dropdown-menu').toggle();
            e.stopPropagation();
            e.preventDefault();
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
 /*---------------- Shop Slider ------------------*/
                $('.shop-slider').bxSlider({
                    pagerCustom: '#shop-slider-nav',
                    mode: 'vertical',
                    controls: false
                });
                $('#shop-slider-nav').bxSlider({
                    slideWidth: 150,
                    minSlides: 3,
                    maxSlides: 3,
                    mode: 'vertical',
                    controls: true,
                    slideMargin: 10,
                    infiniteLoop: false

                });

     // This button will increment the value
                $('.btn.plus').click(function (e) {

                    // Stop acting like a button
                    e.preventDefault();
                    // Get the field name
                    fieldName = $(this).attr('field');
                    // Get its current value
                    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
                    // If is not undefined
                    if (!isNaN(currentVal)) {
                        // Increment
                        $('input[name=' + fieldName + ']').val(currentVal + 1);
                    } else {
                        // Otherwise put a 0 there
                        $('input[name=' + fieldName + ']').val(1);
                    }
                });
                // This button will decrement the value till 0
                $(".btn.minus").click(function (e) {

                    // Stop acting like a button
                    e.preventDefault();
                    // Get the field name
                    fieldName = $(this).attr('field');
                    // Get its current value
                    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
                    // If it isn't undefined or its greater than 0
                    if (!isNaN(currentVal) && currentVal > 1) {
                        // Decrement one
                        $('input[name=' + fieldName + ']').val(currentVal - 1);
                    } else {
                        // Otherwise put a 0 there
                        $('input[name=' + fieldName + ']').val(1);
                    }
                });

                 $('[data-behavior=accordion]').simpleAccordion({});

                 /*---------------- Featured Slider ------------------*/
    $('.featured-products').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerPadding: '40px',
        arrows: true,
        responsive: [
            {
                breakpoint: 1501,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow_custom"] && !Shopify.designMode) return;
  try {
    

 $('.main-slider').slick({
        autoplay: false,
        arrows: false,
        dots: true
    });


  } catch(e) { console.error(e); }
})();
})();
